import React from "react";
import AsyncSelect from "react-select/async";
import UserService from "../services/user.service";
import type { ClientSummary } from "../pages/models";

type ClientAutocompleteProps = {
  value: ClientSummary | null;
  onChange: (client: ClientSummary | null) => void;
  onBlur?: () => void;
  isDisabled?: boolean;
  placeholder?: string;
  name?: string;
};

const ClientAutocomplete = ({
  value,
  onChange,
  onBlur,
  isDisabled,
  placeholder,
  name,
}: ClientAutocompleteProps) => {
  const menuPortalTarget = typeof document !== "undefined" ? document.body : null;

  const loadOptions = async (inputValue: string): Promise<ClientSummary[]> => {
    if (!inputValue) {
      // Return empty or fetch default initial clients
      return [];
    }
    try {
      const response = await UserService.searchClients(inputValue);
      const data = response.data.data || response.data.results || response.data;
      return Array.isArray(data) ? (data as ClientSummary[]) : [];
    } catch (error) {
      console.error("Error fetching clients", error);
      return [];
    }
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      menuPortalTarget={menuPortalTarget}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }) }}
      getOptionLabel={(option) => option.clientName}
      getOptionValue={(option) => option.id || ""}
      value={value}
      onChange={onChange}
      onBlur={() => onBlur?.()}
      isDisabled={isDisabled}
      placeholder={placeholder}
      name={name}
      isClearable
    />
  );
};

export default ClientAutocomplete;
